<template>
  <section class="location-page-container">
    <div class="search-container">
      <div class="form">
        <div class="form-fields-stack w-mob regions">

          <div class="form-field text search">

            <input
              type="text"
              class="form-control"
              placeholder="Search by keyword"
              v-model="payload.keyword"
              @keyup.enter="loadLocations(true)"
            >

            <img
              src="/images/icons/geo-location-gray.svg" alt=""
              class="geolocate"
              @click="$refs.mymap.geolocate()"
            >
          </div>

        </div>

        <div class="filters">
          <div class="filter-links">
            <a
              @click="toggleShow('regions')"
            >
              Regions
              <img src="/images/icons/icon_arrow_down.svg" :class="{ up: showRegionFilter }"/>
            </a>
            <div class="filter-dropdown " v-if="showRegionFilter" v-on-clickaway="() => showRegionFilter = false">
              <ul>
              <li v-for="(region, index) of mapRegions"
                :key="index"
                class="filter-dropdown-item form-field checkbox"
              >
                <div class="custom-checkbox-radio">
                <!-- <input type="checkbox"
                  :value="region.title"
                  v-model="selected_region"

                > -->
                <span class="title" @click="check(null, 'regions', region)">{{ region.title }}</span>
              </div>
              </li>
              </ul>
            </div>
            <a
              @click="toggleShow('locations')"
            >
              Service Types
              <img src="/images/icons/icon_arrow_down.svg" :class="{ up: showLocationTypeFilter }"/>
            </a>
            <div class="filter-dropdown" v-if="showLocationTypeFilter" v-on-clickaway="() => showLocationTypeFilter = false">
              <ul>
                <li v-for="(type, index) of mapTypes"
                  :key="index"
                  class="filter-dropdown-item form-field checkbox"
                >
                <div class="custom-checkbox-radio">
                  <input type="checkbox"
                    :id="type.title"
                    :value="type.title"
                    v-model="selected_types"
                  >
                  <label :for="type.title" class="title">{{ type.title }}</label>
                </div>
                </li>
                <li class="flex clear" @click="selected_types = []">
                  <img src="/images/icons/clear-lblue.svg" alt="">
                  Clear all
                </li>
              </ul>
            </div>
          </div>
          <div class="filter-list">
            <button v-if="selected_region.length > 0" class="filtered-button" @click="selected_region = []">
              <img src="/images/icons/clear-lblue.svg">
              {{selected_region[0]}}
            </button>

            <span v-if="selected_types.length > 0">
              <button v-for="(type, index) in selected_types" :key="index"  class="filtered-button" @click="selected_types.splice(index, 1)">
                <img src="/images/icons/clear-lblue.svg">
                {{type}}
              </button>
            </span>
          </div>

          <button class="filter-button"  @click="loadLocations(true)">Search</button>

        </div>

      </div>
    </div>
    <div class="locations-container flex">
      <div class="locations-list" :class="{ 'active' : view === 'list' }">

        <div class="results">

          <article
            v-for="article of places"
            :key="article.id"
          >
            <a :href="article.url" class="title">
              <h3>{{ article.title }}</h3>
            </a>
            <div class="content">
              <div class="location flex">
                <img src="/images/location.svg" alt="">
                <span v-html="article.address"></span>
              </div>

            <a :href="'tel:'+article.phone" class="phone flex">
              <img src="/images/phone.svg" alt="">
              <span>{{ article.phone }}</span>
            </a>

            <a class="map" @click="showInMap(article)">View on Map</a>

            <a
              class="services"
              @click="toggleServices(article)"
            >
              <span v-if="article.show"><span class="circle">+</span> Show Services</span>
              <span v-else><span class="circle close">-</span> Hide Services</span>
            </a>

              <ul class="list" v-if="!article.show">
                <li
                  class="button grey-border"
                  v-for="(feature, indx) of article.features"
                  :key="indx"
                >
                  {{feature}}
                </li>
              </ul>
            </div>

            <div class="detail-buttons">
              <!-- <a
                class="map"
                @click="toggleServices(article)"
              >
                <span v-if="article.show">Show Services +</span>
                <span v-else>Hide Services -</span>
              </a> -->
              <a
                :href="article.url"
                class="map details"
                :class="{ full: !article.book_now }"
              >
                View Details
              </a>
              <a v-if="article.book_now" :href="article.book_now">
                 Book Now
              </a>
            </div>

          </article>

        </div>

      </div>

      <app-map
        :class="{ 'active' : view === 'map' }"
        ref="mymap"
        :latitude="center.latitude"
        :longitude="center.longitude"
        :zoomed="init_zoom"
        :initmarkers="locations"
        v-on:draggedLatLong="newCoords"
      ></app-map>

      <div class="buttons-toggle" :class="{ 'unfix' : !fixed }">
        <button @click="switchView('map')" :class="{ 'active' : view === 'map' }">View Map</button>
        <button @click="switchView('list')" :class="{ 'active' : view === 'list' }">List View</button>
      </div>
    </div>
  </section>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import { orderByDistance } from 'geolib'
import { directive as onClickaway } from 'vue-clickaway2'

export default {
  components: {
    VueGoogleAutocomplete,
    orderByDistance
	},

  directives: { onClickaway },

  props: {
    types: Array,
    regions: Array,
    locations: Array
  },

  data () {
    return {
      view: null,
      scrollTop: 0,
      show_filters: false,
      places: [],
      payload: {
        keyword: null,
        module_type: this.module_type,
        latitude: 0,
        longitude: 0
      },
      center: {
        latitude: -36.8473374,
        longitude: 174.7479545
      },
      init_zoom: null,
      selected_types: [],
      selected_region: [],
      showRegionFilter: false,
      showLocationTypeFilter: false,
      mapRegions: [],
      mapTypes: []
    }
  },

  computed: {
    // selectedRegion () {
    //   if (this.selected_region !== 'All') {
    //     return this.regions.find(obj => obj.title === this.selected_region)
    //   } else {
    //     return 'All'
    //   }
    // },

    // articles () {
    //   return this.places.filter(place => place.show === true)
    // },



    fixed () {
      let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      if ( this.scrollTop >= (height - 167 - 344) ) {
        return false
      } else {
        return true
      }
    }
  },

  watch: {
    // 'selected_types': function (val) {
    //     console.log('val type', val)
    //     this.selected_types = [val]
    //     // this.loadLocations()
    // },
    // 'selected_region': function (val) {
    //     console.log('val type', val)
    //     this.selected_region = [val]
    //     // this.loadLocations()
    // }
  },

  mounted () {
    this.places = this.locations

    window.addEventListener('scroll', () => {
      this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || document.querySelector(this.el).scrollTop;
    }, true)

    if (this.getBrowserWidth() >= 767) {
      this.view = null
    } else {
      this.view = 'list'
    }

    this.mapRegions = Object.keys(this.regions).map((k) => {
        return {
          title: this.regions[k].title,
          id: this.regions[k].id,
          checked: false
        }
      })

    this.mapTypes = Object.keys(this.types).map((k) => {
        return {
          title: this.types[k].title,
          id: this.types[k].id,
          checked: false
        }
      })

    if (window.location.search) {
      let url = new URL(window.location.href)
      let keyword = url.searchParams.get('keyword')
      let type = url.searchParams.get('type')
      let region = url.searchParams.get('region')
      let latitude = url.searchParams.get('latitude')
      let longitude = url.searchParams.get('longitude')
      let view = url.searchParams.get('view')

      if (keyword) {
        this.payload.keyword = keyword
        this.show_filters = true
      }
      if (type && type !== 'All') {
        this.selected_types = type.split(',')
        this.show_filters = true
      }
      if (region && region !== 'All') {
        this.selected_region = [region]
        let firstRegionResult = this.locations.find(obj => obj.regions[0] === this.selected_region[0])

        if(firstRegionResult) {
          this.payload.latitude = firstRegionResult.latitude
          this.payload.longitude = firstRegionResult.longitude
          this.center.latitude = parseFloat(firstRegionResult.latitude)
          this.center.longitude = parseFloat(firstRegionResult.longitude)
          this.init_zoom = 10
          this.show_filters = true
        }
      }
      if (latitude) {
        this.payload.latitude = latitude
      }
      if (longitude) {
        this.payload.longitude = longitude
      }
      if (view) {
        this.view = view
      }
      this.loadLocations()
    }
  },

  methods: {
    getBrowserWidth () {
      if (self.innerWidth) {
        return self.innerWidth;
      }
      if (document.documentElement && document.documentElement.clientWidth) {
        return document.documentElement.clientWidth;
      }
      if (document.body) {
        return document.body.clientWidth;
      }
    },
    toggleShow (filter) {
        if (filter === 'regions') {
            this.showRegionFilter = !this.showRegionFilter
            this.showLocationTypeFilter = false
        } else {
            this.showRegionFilter = false
            this.showLocationTypeFilter = !this.showLocationTypeFilter
        }
    },
    switchView (view) {
      this.view = view
      this.loadLocations()
    },

    toggleServices (location) {
      location.show = !location.show
    },

    toggleFilters () {
      this.show_filters = !this.show_filters
    },

    getAddressData (addressData, placeResultData, id) {
      this.payload.latitude = addressData.latitude
      this.payload.longitude = addressData.longitude
      this.center.latitude = this.payload.latitude
      this.center.longitude = this.payload.longitude
      this.loadLocations()

    },

    clearAll () {
      this.payload.keyword = ''
      this.selected_types = []
      this.selected_region = []
      this.payload.latitude = 0
      this.payload.longitude = 0
      // this.$refs.autocomplete.clear()
      this.places = this.locations
      this.loadLocations(true)
    },

    newCoords (location) {
      this.payload.latitude = location.lat
      this.payload.longitude = location.lng
      this.loadLocations()
    },

    buildUrl () {
      let url = '?'

      if (this.selected_types.length > 0) {
        let types = ''
        for(let a = 0; a < this.selected_types.length; a++) {
            if (a === 0) {
                types += this.selected_types[a]
            } else {
                types += ','+this.selected_types[a]
            }
            console.log('types', types)
        }
        url += 'type=' + types
      } else {
          url += 'type=All'
      }

      if (this.selected_region.length > 0) {
        url += '&region=' + this.selected_region[0]
      } else {
        url += '&region=All'
      }

      if (this.payload.latitude) {
        url += '&latitude=' + this.payload.latitude
      }
      if (this.payload.longitude) {
        url += '&longitude=' + this.payload.longitude
      }
      if (this.payload.keyword) {
        url += '&keyword=' + this.payload.keyword
      }
      if (this.view) {
        url += '&view=' + this.view
      }

      history.pushState(this.payload, '', '/about-us/locations' + url)
    },

    loadLocations (reload = false) {
      this.buildUrl()

      if (reload) {
          location.reload()
      }

      // NOTE: Hide for Now. Should show result on reload
      // if (this.payload.latitude !== 0 && this.payload.longitude !== 0) {
      //   let center = {
      //     latitude: parseFloat(this.payload.latitude),
      //     longitude: parseFloat(this.payload.longitude)
      //   }

      //   let sortedCoordinates = orderByDistance(center, this.locations)
      //   this.places = []

      //   setTimeout(() => {
      //     this.places = sortedCoordinates
      //     this.filterOptions(this.places)
      //     this.$store.commit('setLoading', false)
      //   }, 100)
      // } else {
      //   this.filterOptions(this.locations)
      //   this.$store.commit('setLoading', false)
      // }

    },

    filterOptions (list) {
      // only types chosen
      if (this.selected_types.length > 0 && this.selected_region.length === 0) {
        this.places = list.filter(place  => place.types.includes(this.selected_types[0]))
      }
      // only region chosen
      if (this.selected_region.length > 0 && this.selected_types.length === 0) {
        this.places = list.filter(place  => place.regions.includes(this.selected_region[0]))
      }
      // both chosen
      if (this.selected_types.length > 0 && this.selected_region.length > 0 ) {
        this.places = list.filter(place  => place.types.includes(this.selected_types[0]) && place.regions.includes(this.selected_region[0]))
      }
      // none chosen
      if (this.selected_types.length === 0 && this.selected_region.length === 0) {
        this.places = list
      }
    },

    showInMap(article) {
        console.log('article', article)
        this.center.latitude = article.latitude
        this.center.longitude = article.longitude
        this.init_zoom = 10;
    },

    check (e, type, value) {
      if (type === 'regions') {
        this.selected_region = [value.title]
      } else {

        if(this.selected_types.includes(value.title)) {
            let index = this.selected_types.indexOf(value.title);
            if (index > -1) {
                this.selected_types.splice(index, 1);
            }
        } else {
            this.selected_types.push(value.title)
        }
        console.log('types', this.selected_types)
      }
      this.showRegionFilter = false
    //   this.loadLocations(true)
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/locations/IndexWithMap.vue